import { useRef, useEffect } from 'react';

const mountedZIndexes=[];

export default function Modal({open,onClose,children,width=500,maxWidth='95vw',maxHeight='85vh',padding=24,zIndex=30,backdropPadding=16,overflow='auto',t}){
if(!open)return null;
const backdropRef=useRef(null);
const mouseDownOnBackdrop=useRef(false);

useEffect(()=>{
  mountedZIndexes.push(zIndex);
  function onKey(e){if(e.key==='Escape'&&zIndex>=Math.max(...mountedZIndexes))onClose();}
  document.addEventListener('keydown',onKey);
  return()=>{document.removeEventListener('keydown',onKey);const idx=mountedZIndexes.lastIndexOf(zIndex);if(idx>=0)mountedZIndexes.splice(idx,1);};
},[onClose,zIndex]);

return(
<div ref={backdropRef} data-modal="true" style={{position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.5)',zIndex,display:'flex',alignItems:'center',justifyContent:'center',padding:backdropPadding}}
  onMouseDown={e=>{mouseDownOnBackdrop.current=e.target===e.currentTarget;}}
  onMouseUp={e=>{if(e.target===e.currentTarget&&mouseDownOnBackdrop.current)onClose();mouseDownOnBackdrop.current=false;}}>
<div style={{background:t.cd,borderRadius:12,border:`1px solid ${t.bd}`,padding,width,maxWidth,maxHeight,overflow}}>
{children}
</div>
</div>);
}
